<!--
 * @Description: 工作任务 临时工作 完成 详情
 * @Author: PF
 * @Date: 2023-03-22 19:04:23
 * @LastEditors: PF
 * @LastEditTime: 2024-02-05 10:21:46
-->
<template>
  <div>
    <el-dialog class="w800 hp80" :model-value="openWanCheng" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openWanCheng', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="工作任务标题" label-align="right" align="left" width="130px" span="2">{{ruleForm.gzrwbt}}</el-descriptions-item>
        <el-descriptions-item label="类别" label-align="right" align="left" width="130px" span="2">{{ruleForm.dbgzlbmc}}</el-descriptions-item>
        <el-descriptions-item label="委派人" label-align="right" align="left" span="2">{{ruleForm.wprxm}}</el-descriptions-item>
        <el-descriptions-item label="开始时间" label-align="right" align="left" span="2">{{ruleForm.kssj}}</el-descriptions-item>
        <el-descriptions-item label="完成时间" label-align="right" align="left" span="2">{{ruleForm.wcsj}}</el-descriptions-item>
        <el-descriptions-item label="要求完成时间" label-align="right" align="left" width="130px" span="2">{{ruleForm.yqwcsj}}</el-descriptions-item>
        <el-descriptions-item label="未按时完成说明" label-align="right" align="left" v-if="!sfaswc" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.waswcsm"></p>
        </el-descriptions-item>
        <el-descriptions-item label="待办内容" label-align="right" align="left" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.dbnr"></p>
        </el-descriptions-item>
        <el-descriptions-item label="工作总结" label-align="right" align="left" span="4">
          <p v-if="ruleForm.gzzj" style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.gzzj.gzzj"></p>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openWanCheng', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue'
import { closeWindow, loadData } from '@/api/common.js'

const props = defineProps({
  openWanCheng: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openWanCheng', 'ReturnData'])

const ruleForm = ref({})
const sfaswc = ref(true)

// 比较两个日期大小。格式：2018-8-12 12:30
const compareDate2 = (d1, d2) => {
  const date1 = new Date(Date.parse(d1))
  const date2 = new Date(Date.parse(d2))
  return date1 > date2
}
// 是否按时完成
const shiFouAnShiWanCheng = () => {
  if (compareDate2(ruleForm.value.wcsj, ruleForm.value.yqwcsj)) {
    sfaswc.value = false
  } else {
    sfaswc.value = true
  }
}

watch(
  () => props.openWanCheng,
  () => {
    if (props.openWanCheng) {
      loadData({
        url: '/api/v2/bangong/bangongdaibanshixiang/bangong/' + props.row.id,
        ruleForm,
        loadSuccess: function () {
          shiFouAnShiWanCheng()
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
